module.exports = __webpack_public_path__ + "img/girl.27fcada6.png";